__turbopack_context__.v({
  "article": "index-module-scss-module__pRJeWq__article",
});
